import { GstModuleTypes } from "./gstModuleTypes";

export const gstModuleReducer = {
  resetGstModuleFetching: (state: GstModuleTypes) => {
    state.fetching = false;
  },
  resetGstModuleSuccess: (state: GstModuleTypes) => {
    state.success = null;
  },
  resetGstModuleError: (state: GstModuleTypes) => {
    state.error = null;
  },
  resetOutwardsData: (state: GstModuleTypes) => {
    state.outwardsData = [];
  },
  resetTotalOutwardsListCount: (state: GstModuleTypes) => {
    state.totalOutwardsListCount = 0;
  },
  resetGstMessage: (state: GstModuleTypes) => {
    state.message = null;
  },
  resetTotalInwardsListCount: (state: GstModuleTypes) => {
    state.totalInwardsListCount = 0;
  },
  resetInwardsData: (state: GstModuleTypes) => {
    state.inwardsData = [];
  },
  resetGstrOneData: (state: GstModuleTypes) => {
    state.gstrOneData = {};
  },
  resetTotalCgstAmount: (state: GstModuleTypes) => {
    state.totalCgstAmount = 0;
  },
  resetTotalIgstAmount: (state: GstModuleTypes) => {
    state.totalIgstAmount = 0;
  },
  resetTotalInvoiceValue: (state: GstModuleTypes) => {
    state.totalInvoiceValue = 0;
  },
  resetTotalSgstAmount: (state: GstModuleTypes) => {
    state.totalSgstAmount = 0;
  },
  resetTotalTaxableValue: (state: GstModuleTypes) => {
    state.totalTaxableValue = 0;
  },
  resetTotalItcAmount: (state: GstModuleTypes) => {
    state.totalItcAmount = 0;
  },
  resetGstrInvoiceList: (state: GstModuleTypes) => {
    state.gstrOneInvoiceList = [];
  },
  resetGstrThreeBInvoiceList: (state: GstModuleTypes) => {
    state.gstrThreeBInvoiceList = [];
  },
  resetGstrOnehsnWiseList: (state: GstModuleTypes) => {
    state.getGstrOnehsnWiseList = [];
  },
  resetGstrThreeBDataList: (state: GstModuleTypes) => {
    state.gstrThreeBData = [];
  },
  resetGstrTwoAReturnsData: (state: GstModuleTypes) => {
    state.gstrTwoAReturnsData = [];
  },
  resetGstrTwoBReturnsData: (state: GstModuleTypes) => {
    state.gstrTwoBReturnsData = {};
  },
  resetGstFilingError: (state: GstModuleTypes) => {
    state.gstFilingError = null;
  },
  resetGstFilingSuccess: (state: GstModuleTypes) => {
    state.gstFilingSuccess = null;
  },
  resetGstFilingMessage: (state: GstModuleTypes) => {
    state.gstFilingMessage = null;
  },
  resetGstNumberList: (state: GstModuleTypes) => {
    state.gstNumberList = [];
  },
  resetGstCommentsSuccess: (state: GstModuleTypes) => {
    state.gstCommentSuccess = null;
  },
  resetGstOtpError: (state: GstModuleTypes) => {
    state.gstOtpError = null;
  },
  resetGstOtpMessage: (state: GstModuleTypes) => {
    state.gstOtpMessage = null;
  },
  resetGstOtpVerifyError: (state: GstModuleTypes) => {
    state.gstOtpVerifyError = null;
  },
  resetGstOtpVerifyMessage: (state: GstModuleTypes) => {
    state.gstOtpVerifyMessage = null;
  },
  resetGstOtpFetching: (state: GstModuleTypes) => {
    state.gstOtpFetching = false;
  },
  resetGstOtpVerifyFetching: (state: GstModuleTypes) => {
    state.gstOtpVerifyFetching = false;
  },
  resetGstOtpRequestFetching: (state: GstModuleTypes) => {
    state.gstOtpRequestFetching = false;
  },
  resetGstOneFilingACKNumber: (state: GstModuleTypes) => {
    state.gstOneFilingACKNumber = null;
  },
  resetNumberOfInvoices: (state: GstModuleTypes) => {
    state.numberOfInvoices = 0;
    state.numberOfEInvoices= 0;
    state.numberOfUploadInvoices = 0;

  },
  resetGstOneFilingStatus: (state: GstModuleTypes) => {
    state.gstOneFilingStatus = {};
  },
  resetGstOneFilingStatusSuccess: (state: GstModuleTypes) => {
    state.gstOneFilingStatusSuccess = null;
  },
  resetGstOneFilingStatusError: (state: GstModuleTypes) => {
    state.gstOneFilingStatusError = null;
  },
  resetGstOneFilingStatusMessage: (state: GstModuleTypes) => {
    state.gstOneFilingStatusMessage = null;
  },
  resetGstOneFilingStatusStatusCode: (state: GstModuleTypes) => {
    state.gstOneFilingStatusStatusCode = null;
  },
};
